/**
 * Settings slice
 */

import { createAction, createSlice } from '@reduxjs/toolkit';

const initialState = {
  settings: null as any,
  loading: false,
  error: null as string | null,
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setSettings(state, action) {
      state.settings = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    clearError(state) {
      state.error = null;
    },
  },
});

// Reducer
export const settingsReducer = settingsSlice.reducer;

// Actions
export const {
  setSettings,
  setLoading,
  setError,
  clearError,
} = settingsSlice.actions;

// Async Actions
export const fetchSettings = createAction('SETTINGS/FETCH');
export const updateSettings = createAction<any>('SETTINGS/UPDATE');

